import React, { useState } from 'react';
import Sliders from './Sliders';

const TabsPage = () => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState('home');

  // Function to handle tab switch
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="container mt-5">
      {/* Nav tabs */}
      <ul className="nav nav-tabs justify-content-center" style={{border:"none"}} id="myTabs" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            className={`nav-link ${activeTab === 'home' ? 'active' : ''}`}
            id="home-tab"
            onClick={() => handleTabClick('home')}
            role="tab"
            aria-controls="home"
            aria-selected={activeTab === 'home'}
          >
            Best Seller
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className={`nav-link ${activeTab === 'profile' ? 'active' : ''}`}
            id="profile-tab"
            onClick={() => handleTabClick('profile')}
            role="tab"
            aria-controls="profile"
            aria-selected={activeTab === 'profile'}
          >
            Trending
          </a>
        </li>
      </ul>

      {/* Tab content */}
      <div className="tab-content mt-3">
        <div
          className={`tab-pane fade ${activeTab === 'home' ? 'show active' : ''}`}
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <Sliders label={'Best Seller'}/>
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'profile' ? 'show active' : ''}`}
          id="profile"
          role="tabpanel"
          aria-labelledby="profile-tab"
        >
          <Sliders label={'Trending'}/>
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'contact' ? 'show active' : ''}`}
          id="contact"
          role="tabpanel"
          aria-labelledby="contact-tab"
        >
          <h4>Contact Tab</h4>
          <p>This is the content for the Contact tab.</p>
        </div>
      </div>
    </div>
  );
};

export default TabsPage;
